import {
	createRouter,
	createWebHistory,
	createWebHashHistory
} from 'vue-router'

const routes = [{
		path: '/',
		name: 'shopping_home',
		meta: {
			title: '不凡商城-中高端工具仪器一站式采购平台'
		},
		component: () => import('@/views/shopping_mall/home/Home.vue')
	},
	{
		path: '/sceneCenter.html',
		name: 'SceneCenter',
		meta: {
			title: '不凡商城-场景中心'
		},
		component: () => import('@/views/shopping_mall/sceneCenter/sceneCenter.vue')
	},
	{
		path: '/mine.html',
		name: 'mine',
		meta: {
			title: '不凡商城-用户中心'
		},
		component: () => import('@/views/shopping_mall/mine/mine.vue'),
		// children:[
		//   {
		//     path: 'mineOption',
		//     name: 'mineOption',
		//     meta:{
		//           title: '个人中心设置'
		//     },
		//     component:import('@/views/mine/components/mineOption.vue')
		//   }
		// ]
	},
	{
		path: '/mine/mineOption.html',
		name: 'mineOption',
		meta: {
			title: '不凡商城-个人中心设置'
		},
		component: () => import('@/views/shopping_mall/mine/components/mineOption.vue')
	},
	{
		path: '/mine/customization.html',
		name: 'customization',
		meta: {
			title: '不凡商城-客户定制'
		},
		component: () => import('@/views/shopping_mall/customization/CustomerCustomization.vue')
	},
	{
		path: '/customer-share.html',
		name: 'customerShare',
		redirect: to => ({
			path: '/mine/customization.html',
			query: to.query
		})
	},
	{
		path: '/marketing/dataMarketing.html',
		name: 'dataMarketing',
		meta: {
			title: '不凡商城-数采营销'
		},
		component: () => import('@/views/shopping_mall/marketing/dataMarketing.vue')
	},
	{
		path: '/marketing/zhiMarketing.html',
		name: 'zhiMarketing',
		meta: {
			title: '不凡商城-智采营销'
		},
		component: () => import('@/views/shopping_mall/marketing/zhiMarketing.vue')
	},
	{
		path: '/mine/customizationCenter.html',
		name: 'customizationCenter',
		meta: {
			title: '不凡商城-客户定制中心'
		},
		component: () => import('@/views/shopping_mall/customization/CustomerCustomizationCenter.vue')
	},
	{
		path: '/mine/quotation.html',
		name: 'quotation',
		meta: {
			title: '不凡商城-报价中心'
		},
		component: () => import('@/views/shopping_mall/quotation_center/quotation.vue')
	},
	{
		path: '/mine/afterSale.html',
		name: 'afterSale',
		meta: {
			title: '不凡商城-售后审核'
		},
		component: () => import('@/views/shopping_mall/afterSale_center/afterSale.vue')
	},
	{
		path: '/mine/invoiceCenter.html',
		name: 'invoiceCenter',
		meta: {
			title: '不凡商城-我的发票'
		},
		component: () => import('@/views/shopping_mall/invoiceCenter/invoiceCenter.vue')
	},
	{
		path: '/mine/boliweiMyself.html',
		name: 'boliweiMyself',
		meta: {
			title: '不凡商城-智采订单管理'
		},
		component: () => import('@/views/shopping_mall/boliweiMyself/boliweiMyself.vue')
	},
	{
		path: '/mine/dataMyself.html',
		name: 'dataMyself',
		meta: {
			title: '不凡商城-数采订单管理'
		},
		component: () => import('@/views/shopping_mall/dataMyself/dataMyself.vue')
	},
	{
		path: '/mine/shorturL.html',
		name: 'shorturL',
		meta: {
			title: '不凡商城-短链管理'
		},
		component: () => import('@/views/shopping_mall/shorturL/management.vue')
	},
	{
		path: '/mine/reconciliation.html',
		name: 'reconciliation',
		meta: {
			title: '不凡商城-订单管理'
		},
		component: () => import('@/views/shopping_mall/reconciliation/reconciliation.vue')
	},
	{
		path: '/mine/connection.html',
		name: 'connection',
		meta: {
			title: '不凡商城-客户中心'
		},
		component: () => import('@/views/shopping_mall/connection/connection.vue')
	},
	{
		path: '/orderCenter.html',
		name: 'orderCenter',
		meta: {
			title: '不凡商城-订单中心'
		},
		component: () => import('@/views/shopping_mall/order_center/orderCenter.vue'),
	},
	{
		path: '/collection.html',
		name: 'collection',
		meta: {
			title: '不凡商城-收藏夹'
		},
		component: () => import('@/views/shopping_mall/collection/collection.vue'),
	},
	{
		path: '/orderCenter/orderCenterDetail.html',
		name: 'orderCenterDetail',
		meta: {
			title: '不凡商城-订单详情'
		},
		component: () => import('@/views/shopping_mall/order_center/components/orderCenterDetail.vue')
	},
	{
		path: '/order.html',
		name: 'order',
		meta: {
			title: '不凡商城-创建订单信息'
		},
		component: () => import('@/views/shopping_mall/order/order.vue')
	},
	{
		path: '/moreOrder.html',
		name: 'moreOrder',
		meta: {
			title: '不凡商城-批量下单'
		},
		component: () => import('@/views/shopping_mall/order/components/moreOrder.vue')
	},
	{
		path: '/orderCenter/orderAfterSales.html',
		name: 'orderAfterSales',
		meta: {
			title: '不凡商城-售后服务'
		},
		component: () => import('@/views/shopping_mall/order_center/components/orderAfterSales.vue')
	},
	{
		path: '/shoppingCart.html',
		name: 'shoppingCart',
		meta: {
			title: '不凡商城-购物车'
		},
		component: () => import('@/views/shopping_mall/shopping_cart/shoppingCart.vue')
	},
	{
		path: '/login.html',
		name: 'Login',
		meta: {
			title: '不凡商城-登录'
		},
		component: () => import('@/views/shopping_mall/login/login.vue')
	},
	{
		path: '/register.html',
		name: 'Register',
		meta: {
			title: '不凡商城-企业注册'
		},
		component: () => import('@/views/shopping_mall/register/register.vue')
	},
	{
		path: '/personal.html',
		name: 'Personal',
		meta: {
			title: '不凡商城-个人注册'
		},
		component: () => import('@/views/shopping_mall/register/personal.vue')
	},
	{
		path: '/modify.html',
		name: 'modify',
		meta: {
			title: '不凡商城-忘记密码'
		},
		component: () => import('@/views/shopping_mall/register/modify.vue')
	},
	{
		path: '/classiFication.html',
		name: 'ClassiFication',
		meta: {
			title: '不凡商城-商品分类'
		},
		component: () => import('@/views/shopping_mall/classiFication/classiFication.vue')
	},
	{
		path: '/classiFicationBF.html',
		name: 'ClassiFicationBF',
		meta: {
			title: '不凡商城-A-BF品牌'
		},
		component: () => import('@/views/shopping_mall/classiFication/classiFicationBF.vue')
	},
	{
		path: '/logins/mallDetails/:id.html',
		name: 'MallDetails',
		meta: {
			title: '不凡商城-商品详情'
		},
		component: () => import('@/views/shopping_mall/mall_details/mallDetails.vue')
	},
	{
		path: '/aboutus.html',
		name: 'AboutUs',
		meta: {
			title: '不凡商城-资讯详情'
		},
		component: () => import('@/views/shopping_mall/footer_info/footer_info.vue')
	},
	{
		path: '/realTimeInfo.html',
		name: 'realTimeInfo',
		meta: {
			title: '不凡商城-资讯'
		},
		component: () => import('@/views/shopping_mall/real_time_info/real_time_info.vue')
	},
	{
		path: '/login/loginMiddle.html',
		name: 'loginMiddle',
		meta: {
			title: '不凡商城-登陆中。。。'
		},
		component: () => import('@/views/shopping_mall/login/login_middle.vue')
	},
	// {
	// 	path: '/question_center.html',
	// 	name: 'questionCenter',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/question.vue')
	// },
	// {
	// 	path: '/question_detail.html',
	// 	name: 'question_detail',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/questionDetail.vue')
	// },
	// {
	// 	path: '/question_reward.html',
	// 	name: 'questionReward',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/rewardList.vue')
	// },
	// {
	// 	path: '/create_post.html',
	// 	name: 'createPost',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/createPost.vue')
	// },
	// {
	// 	path: '/question_login.html',
	// 	name: 'question_login',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/question_login.vue')
	// },
	// {
	// 	path: '/user-center.html',
	// 	name: 'userCenter',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/userCenter.vue')
	// },
	// {
	// 	path: '/user-profile.html',
	// 	name: 'userProfile',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/userProfile.vue')
	// },
	// {
	// 	path: '/question_answer_detail.html',
	// 	name: 'questionAnswerDetail',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/questionAnswerDetail.vue')
	// },
	// {
	// 	path: '/article_detail.html',
	// 	name: 'articleDetail',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/articleDetail.vue')
	// },
	// {
	// 	path: '/question_search.html',
	// 	name: 'questionSearch',
	// 	meta: {
	// 		title: '不凡智库社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/question_center/questionSearch.vue')
	// },
	// // xBotPark相关路由
	// {
	// 	path: '/xBotPark_question_detail.html',
	// 	name: 'xBotParkQuestionDetail',
	// 	meta: {
	// 		title: 'xBotPark社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/xBotPark/questionDetail.vue')
	// },
	// {
	// 	path: '/xBotPark_create_post.html',
	// 	name: 'xBotParkCreatePost',
	// 	meta: {
	// 		title: 'xBotPark社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/xBotPark/createPost.vue')
	// },
	// {
	// 	path: '/xBotPark_user-center.html',
	// 	name: 'xBotParkUserCenter',
	// 	meta: {
	// 		title: 'xBotPark社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/xBotPark/userCenter.vue')
	// },
	// {
	// 	path: '/xBotPark_user-profile.html',
	// 	name: 'xBotParkUserProfile',
	// 	meta: {
	// 		title: 'xBotPark社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/xBotPark/userProfile.vue')
	// },
	// {
	// 	path: '/xBotPark_question_answer_detail.html',
	// 	name: 'xBotParkQuestionAnswerDetail',
	// 	meta: {
	// 		title: 'xBotPark社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/xBotPark/questionAnswerDetail.vue')
	// },
	// {
	// 	path: '/xBotPark_article_detail.html',
	// 	name: 'xBotParkArticleDetail',
	// 	meta: {
	// 		title: 'xBotPark社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/xBotPark/articleDetail.vue')
	// },
	// {
	// 	path: '/xBotPark_question_search.html',
	// 	name: 'xBotParkQuestionSearch',
	// 	meta: {
	// 		title: 'xBotPark社区'
	// 	},
	// 	component: () => import('@/views/shopping_mall/xBotPark/questionSearch.vue')
	// },
	// 商机
	{
		path: '/niche_home.html',
		name: 'nicheHome',
		meta: {
			title: '不凡商城-商机'
		},
		component: () => import('@/views/shopping_mall/business_opportunity/niche_home.vue')
	},
	{
		path: '/niche_list.html',
		name: 'nicheList',
		meta: {
			title: '不凡商城-商机列表'
		},
		component: () => import('@/views/shopping_mall/business_opportunity/niche_list.vue')
	},
	{
		path: '/niche_form.html',
		name: 'nicheForm',
		meta: {
			title: '不凡商城-商机编辑'
		},
		component: () => import('@/views/shopping_mall/business_opportunity/niche_form.vue')
	},
	{
		path: '/niche_detail.html',
		name: 'nicheDetail',
		meta: {
			title: '不凡商城-商机详情'
		},
		component: () => import('@/views/shopping_mall/business_opportunity/niche_detail.vue')
	},
	{
		path: '/niche_shop.html',
		name: 'nicheShop',
		meta: {
			title: '不凡商城-兑换商城'
		},
		component: () => import('@/views/shopping_mall/business_opportunity/niche_shop.vue')
	},
	{
		path: '/niche_shopDetail.html',
		name: 'nicheShopDetail',
		meta: {
			title: '不凡商城-兑换商品详情'
		},
		component: () => import('@/views/shopping_mall/business_opportunity/niche_shopDetail.vue')
	},
	{
		path: '/niche_exchange.html',
		name: 'nicheExchange',
		meta: {
			title: '不凡商城-积分兑换'
		},
		component: () => import('@/views/shopping_mall/business_opportunity/niche_exchange.vue')
	},
	{
		path: '/niche_record.html',
		name: 'nicheRecord',
		meta: {
			title: '不凡商城-积分兑换记录'
		},
		component: () => import('@/views/shopping_mall/business_opportunity/niche_record.vue')
	},
	// 选型中心
	{
		path: '/model_home.html',
		name: 'model_home',
		meta: {
			title: '不凡选型中心-中高端工具仪器一站式采购平台'
		},
		component: () => import('@/views/model_center/home/Home.vue')
	},
	{
	  path: '/model_mine.html',
	  name: 'model_mine',
	  meta:{
	        title: '选型中心-用户中心'
	  },
	  component:() => import('@/views/model_center/mine/mine.vue'),
	},
	{
	  path: '/model_center/model_mineOption.html',
	  name: 'model_mineOption',
	  meta:{
	        title: '选型中心-个人中心设置'
	  },
	  component:() => import('@/views/model_center/mine/components/mineOption.vue')
	},
	{
		path: '/model_center/mallDetails/:id.html',
		name: 'model_MallDetails',
		meta: {
			title: '选型中心-商品详情'
		},
		component: () => import('@/views/model_center/mall_details/mallDetails.vue')
	},
	{
	  path: '/model_center/question_center.html',
	  name: 'question_center',
	  meta:{
	        title: '选型中心-问答中心'
	  },
	  component:() => import('@/views/model_center/question_center/question.vue'),
	},
	{
	  path: '/model_center/questionDetail.html',
	  name: 'questionDetail',
	  meta:{
	        title: '选型中心-问答中心'
	  },
	  component:() => import('@/views/model_center/question_center/components/questionDetail.vue'),
	},
	{
	  path: '/model_center/contrast_center.html',
	  name: 'contrast_center',
	  meta:{
	        title: '选型中心-对比中心'
	  },
	  component:() => import('@/views/model_center/contrast_center/contrast.vue'),
	},
	{
	  path: '/model_center/contrastDetail.html',
	  name: 'contrastDetail',
	  meta:{
	        title: '选型中心-对比中心'
	  },
	  component:() => import('@/views/model_center/contrast_center/components/contrastDetail.vue'),
	},
	{
	  path: '/model_center/scene_center.html',
	  name: 'scene_center',
	  meta:{
	        title: '选型中心-场景中心'
	  },
	  component:() => import('@/views/model_center/scene_center/scene.vue'),
	},
	{
	  path: '/model_center/sceneDetail.html',
	  name: 'sceneDetail',
	  meta:{
	        title: '选型中心-方案中心'
	  },
	  component:() => import('@/views/model_center/scene_center/components/sceneDetail.vue'),
	},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// const router = createRouter({
// 	history: createWebHashHistory(process.env.BASE_URL),
// 	routes
// })

// 全局前置守卫，处理不带.html的路径跳转
router.beforeEach((to, from, next) => {
  // 检查路径是否已经以.html结尾
  if (to.path && !to.path.endsWith('.html') && to.path !== '/') {
    // 如果路径不是根路径且不以.html结尾，重定向到带.html的路径
    next({
      path: to.path + '.html',
      query: to.query
    })
  } else {
    next()
  }
})

export default router
